/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import r from"../../../core/Error.js";class s extends r{constructor(r,s,e){super(r,s,e),this.name="unknown",this.name=r}}export{s as default};
